import React, {useState,useEffect,useContext} from 'react'
import axios from 'axios'
import Styles from '../../Css/UploadScreen.module.css'
import styles from '../../Css/CustomSettings.module.css'
import '../../Css/Common.css'
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import BackgroundListModal from '../Modals/BackgroundListModal'
import CustomSettings from './CustomSettings'
import DownloadScreen from './DownloadScreen'
import ImageSection from './ImageSection'
import Dropzone from 'react-dropzone'
import { ContextConsumer, AuthContext } from '../../context/GlobalState'
import {delay} from "q"
import alertify from 'alertifyjs'
import 'alertifyjs/build/css/alertify.css';
// redux
import {connect} from 'react-redux'
import {updateImageFileData,updateImageURL} from '../../Redux/Reducers/HomePageReducer/HomePageActionController'

import posthog from 'posthog-js';

// posthog.init("phc_p92egRlXhuEzPYkMaQVakJl0XCI82X507N84clTaJHH", {api_host: 'https://app.posthog.com'});
posthog.init("FoIzpWdbY_I9T_4jr5k4zzNuVJPcpzs_mIpO6y7581M", {api_host: 'https://app.posthog.com'});

function SingleImageProcessing(props) {

    const cookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1]

    const [backgroundId,setBackgroundId] = useState('')
    const [checkWindowTransparency,setCheckWindowTransparency] = useState(false)
    const [checkColorEnhancement,setCheckColorEnhancement] = useState(false)
    const [checkBlurNumberPlate,setCheckBlurNumberPlate] = useState(false)
    const [checkWindowCorrection,setCheckWindowCorrection] = useState(true)//using for seat generation
    const [selectedLogoFile,setSelectedLogoFile] = useState(null)
    const [showlogoCropModal,setShowlogoCropModal] = useState(false)
    const [logoUrl,setLogoUrl] = useState('')
    const [croppedImageUrl,setCroppedImageUrl] = useState(null)
    const [isSolidBackgrounds,setisSolidBackgrounds] = useState(false)
    const [bgList,setBgList] = useState([])
    const [favBgList,setFavBgList] = useState([])
    const [bgCredit, setBgCredit] = useState(null)
    const [showBackgroundList, setShowBackgroundList] = useState(false)
    const [toggleStatus, setToggleStatus] = useState(window.localStorage.getItem("fileList") ? true : false)
    const [isEditingFinish, setIsEditingFinish] = useState(window.sessionStorage.getItem("isEditingFinish") ? window.sessionStorage.getItem("isEditingFinish") :false)
    const [isDelearshipLogo, setIsDelearshipLogo] = useState(false)
    const [numberPlate, setNumberPlate] = useState(null)
    const [isBackgroundBlur, setIsBackgroundBlur] = useState(false)
    const [isEditingStarted, setIsEditingStarted] = useState(window.sessionStorage.getItem("isEditingStarted") ? window.sessionStorage.getItem("isEditingStarted") : false)
    const [isImageHide, setIsImageHide] = useState(JSON.parse(window.sessionStorage.getItem("isImageHide")) ? JSON.parse(window.sessionStorage.getItem("isImageHide")) : false)
    const [angle,setAngle] = useState('')
    const [colorList, setColorList] = useState([])
    const [marketPlaceList, setMarketPlaceList] = useState([])
    const [marketId, setMarketId] = useState(null)
    const [cropImage, setCropImage] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [bgColorCode, setBgColorCode] = useState('')
    const [bgUrl, setbgUrl] = useState('')
    const [checkShadow, setCheckShadow] = useState(false)
    const [cropImageDetails, setCropImageDetails] = useState(null)
    const [modelData, setModelData] = useState([])
    const [modelId, setModelId] = useState(null)
    const [modelPose, setModelPose] = useState([])
    const [poseToDisplay, setPoseToDisplay] = useState([])
    const [applyType, setApplyType] = useState('VS')
    const [customWall, setCustomWall] = useState('')
    const [height, setHeight] = useState('')
    const [wallData, setWallData] = useState([])
    const [applyWay, setApplyWay] = useState('')
    const [checkBodyReflection, setCheckBodyReflection] = useState(false)
    const [checkBrightness, setCheckBrightness] = useState("1")
    const [checkTint, setCheckTint] = useState("0")
    const [checkBlur, setCheckBlur] = useState("")
    const [imageSectionModalImage,setImageSectionModalImage] = useState(null)
    const [shadowType, setShadowType] = useState("soft")
    const [applyShadow,setApplyShadow] = useState(true)
    const [seeThrough, setSeeThrough] = useState(false)
    const [greyScale, setGreyScale] = useState(false)

    const context = useContext(AuthContext)

    const handleCheckShadow = () => {
        setCheckShadow(!checkShadow)
    }

    useEffect(() => {

        let userEmail = cookie("emailId")
        let userId = cookie("userId") 

        let url = window.location.pathname
        let bgAngles

        if(url.includes("food")){
            bgAngles = 0
            setAngle(0)
        }else{
            bgAngles = '' 
        }
        fetchBackground(bgAngles)
        fetchMarketPlace()
        fetchModel()
        if(props.prodCatId === 'cat_d8R14zUNE'){
            fetchCustomWalls()
        }
        if(userId && userEmail && context.auth.loggedIn){
            setIsImageHide(false)
            window.sessionStorage.setItem("isImageHide", false)
        }

        // clear redux
        props.updateImageFileData(null);
        props.updateImageURL('','',0);
    },[])


    const imageProcessing = async (i) => {
        posthog.capture('Web Image Processed',{"isLoggedIn":context.auth.loggedIn})// get loggedIn: true, or false from context api 
        
        let importantParameters = [backgroundId,bgUrl,bgColorCode,poseToDisplay[0],customWall];
        let pass = true
        //console.log(importantParameters)
        for(let i=0;i<importantParameters.length;i++){
            if(importantParameters[i]){
                break;
            }
            if(i+1 === importantParameters.length)
            {
                pass = false;
            }
        }
        if(!pass){
            if(props.categoryType === 'fabric')
                alertify.error('No Pose selected')
            else if(props.categoryType === 'homeFurnishing')
                alertify.error('No Template selected')
            else
                alertify.error('No background selected')
            return;
        }
        setShowBackgroundList(false)
        setIsEditingStarted(true)
        setSpinner(true)
        setToggleStatus(!toggleStatus)
        let projectName = 'prj' + Math.floor(100000 + Math.random() * 900000)
        let skuName = 'sku' + Math.floor(100000 + Math.random() * 900000)
        window.sessionStorage.setItem("isEditingStarted", true)
        let auth_token = cookie('auth_token')
        let enterprise_id = cookie('enterpriseId')
        if(auth_token == null){
            auth_token = 'fe4a909f-9e2f-461f-98fc-51c22a21aac6'
        }
        const fd = new FormData();
        if(props.fileList[0].file == null){
            fd.append("input_image_url",props.fileList[0].url)
        }else{
            fd.append("image", props.fileList[0].file);
        }
        
        fd.append("background_id", backgroundId);
        posthog.capture('Web Car BG Select',{"backgroundID":backgroundId})// send event which records the background user choose
        fd.append("window_status",checkWindowTransparency ? 'inner' : 'outer');
        fd.append("is_color",checkColorEnhancement);
        fd.append("number_plate_blur", checkBlurNumberPlate);
        fd.append("window_correction",checkWindowCorrection)
        fd.append("prod_cat_id",props.prodCatId)
        fd.append("auth_key", auth_token)
        fd.append("prod_sub_cat_id", "prod_Gcg69Rkxa")
        fd.append("enterprise_id", enterprise_id)
        fd.append('processing_type', 'REALTIME')
        fd.append('source', 'SINGLEPROCESS')
        fd.append("wall_url","0");
        fd.append("apply_type",applyType)
        fd.append("custom_wall",customWall)
        fd.append("height",applyWay === 'manually'?height:'mid')
        props.prodCatId === "cat_skJ7HIvnc" && marketId === null ? fd.append("marketplace_id",0): fd.append("marketplace_id",marketId)
            
        
        // fd.append("marketplace_id",marketId)
        fd.append("angle",angle)
        fd.append("bg_url", bgUrl)
        fd.append("bg_color", bgColorCode)
        fd.append("wall_effect", checkShadow?'True':'False')
        fd.append("category", props.subCatName)
        fd.append('body_reflection',checkBodyReflection?1:0)
        fd.append('window_tint',checkTint)
        fd.append('brightness',checkBrightness)
        fd.append('see_through',seeThrough)
        fd.append('seat_generation',checkWindowCorrection)
        fd.append('frame_seq_no',1)
        fd.append('grey_scale',greyScale)

        if(props.prodCatId === "cat_skJ7HIvnc"){
        
            if(applyShadow === false){
                fd.append("shadow_type","none")
                // fd.append("apply_shadow",applyShadow)
            }else{
                fd.append("shadow_type",shadowType)
                // fd.append("apply_shadow",applyShadow)
            }
            
        }

        if(props.subCatName === 'suit'){
            if(props.fileList[0].suitFile === ""){// is true in case of try images only
                
                fd.append("suit_img_url",props.fileList[0].suitUrl)
                fd.append("salwar_img_url", props.fileList[0].salwarUrl);
                fd.append("dupatta_img_url", props.fileList[0].dupattaUrl);
            }else{
                fd.append("suit_img", props.fileList[0].suitFile);
                fd.append("salwar_img", props.fileList[0].salwarFile);
                fd.append("dupatta_img", props.fileList[0].dupattaFile);
            }
        }
        else if(props.subCatName === 'bedsheet'){
            if(props.fileList[0].bedsheetFile === ""){// is true in case of try images only
                fd.append("bedsheet_img_url", props.fileList[0].bedsheetUrl);
                fd.append("pillow_img_url", props.fileList[0].pillowUrl);
            }else{
                fd.append("bedsheet_img", props.fileList[0].bedsheetFile);
                fd.append("pillow_img", props.fileList[0].pillowFile);
            }
        }

        if(selectedLogoFile !== null){
            fd.append("logo_number_plate",selectedLogoFile);
        }

        if(props.categoryType === 'fabric' || props.categoryType === 'homeFurnishing'){
            fd.append("project_name",projectName)
            fd.append("sku_name",skuName)
            fd.append("category_type", "image_generation")
            fd.append("total_project_count", poseToDisplay.length)
            fd.append("model_id", modelId);
        }
        
        for(let i=0; i<1 || i<poseToDisplay.length; i++){
            if(props.categoryType === 'fabric' || props.categoryType === 'homeFurnishing'){
                fd.delete('frame_seq_no');
                fd.delete('pose_id');
                fd.append('frame_seq_no',i+1)
                fd.append("pose_id", poseToDisplay[i])
            }
            // let url =  process.env.REACT_APP_BASEURL + `/v2/self-serve/image-process`
            // let data_body = fd
            // let resp = await centralAPI.handlePostRequest(url,data_body)
            // if(resp.axios_request_status === 200){
            //     props.handleApiResponse(resp?.data)
            //     if(props.categoryType == 'fabric' || props.categoryType == 'homeFurnishing'){
            //         props.handle3DRendering(resp?.data)
            //          if(poseToDisplay.length==i+1){
            //             setSpinner(false)
            //             window.sessionStorage.setItem("isEditingFinish", isEditingFinish)

            //             let userEmail = cookie("emailId")
            //             let userId = cookie("userId")

            //             if(!userId && !userEmail && !context.auth.loggedIn){
            //                 setIsEditingFinish(true)
            //                 setTimeout(() => {
            //                     setIsImageHide(true)
            //                     window.sessionStorage.setItem("isImageHide", true)
            //                 },5000)
            //             }
            //         }
            //     }
            //     else {
            //         setCropImage(true)      
            //         setCropImageDetails([resp?.data.output_image_lres_url,[0,0,0,0]])
            //         setSpinner(false)
            //         window.sessionStorage.setItem("isEditingFinish", true)

            //         let userEmail = cookie("emailId")
            //         let userId = cookie("userId")

            //         if(!userId && !userEmail && !context.auth.loggedIn){
            //             setCropImage(false)
            //             setIsEditingFinish(true)
            //             setTimeout(() => {
            //                 setIsImageHide(true)
            //                 window.sessionStorage.setItem("isImageHide", true)
            //             },5000)
            //         }
            //     }
            // }
             axios.post( process.env.REACT_APP_BASEURL + `/v2/self-serve/image-process`,fd)
            .then ( async (resp) => {
                if(resp?.data?.status !== 'Done') alertify.error('Image Failed due to Server Error!!!');
               await props.handleApiResponse(resp?.data)
                setIsEditingFinish(true)
                if(props.categoryType == 'fabric' || props.categoryType == 'homeFurnishing'){
                    props.handle3DRendering(resp?.data)
                     if(poseToDisplay.length==i+1){
                        setSpinner(false)
                        window.sessionStorage.setItem("isEditingFinish", isEditingFinish)

                        let userEmail = cookie("emailId")
                        let userId = cookie("userId")

                        if(!userId && !userEmail && !context.auth.loggedIn){
                            setIsEditingFinish(true)
                            setTimeout(() => {
                                setIsImageHide(true)
                                window.sessionStorage.setItem("isImageHide", true)
                            },5000)
                        }
                    }
                }
                else {
                    if(resp.data.status === 'Done') {
                        const hasWindow = typeof window !== 'undefined';
                        const width = hasWindow ? window.innerWidth : null;
                        if (width>600)
                        setSpinner(false)
                        setCropImageDetails([resp?.data.output_image_lres_url,[0,0,0,0]])
                        setCropImage(true)
                        window.sessionStorage.setItem("isEditingFinish", true)

                        let userEmail = cookie("emailId")
                        let userId = cookie("userId")

                        if(!userId && !userEmail && !context.auth.loggedIn){
                            setCropImage(false)
                            setIsEditingFinish(true)
                            setTimeout(() => {
                                setIsImageHide(true)
                                window.sessionStorage.setItem("isImageHide", true)
                            },5000)
                        }
                    }
                    else {
                        setSpinner(false);
                        setCropImage(false);
                        setIsEditingFinish(true)
                    }
                }

            }).catch((e)=>{
                console.log(e)
            })

        
            if(i==0 && (props.categoryType === 'fabric' || props.categoryType === 'homeFurnishing')){
                await delay(10000)
            }
        }
    // setIsEditingFinish(true)


    }

    

    const fetchCustomWalls = async () => {
        let auth_key = cookie('auth_token')
        if(auth_key == null){
            auth_key = 'fe4a909f-9e2f-461f-98fc-51c22a21aac6'
        }
        // try {
        //     let url = `${process.env.REACT_APP_BASEURL}/v2/backgrounds/custom-walls?auth_key=${auth_key}&category=${props.prodCatId}`
        //     let params = {
        //         auth_key: auth_key,
        //         category: props.prodCatId
        //     }
        //     let response= await centralAPI.handleGetRequest(url,params)
            
        //     if(response.axios_request_status === 200){
                
        //         setWallData(wallData => response.data)
        //         setCustomWall(wall => response.data[0]['wall_png_url'])
        //     }
        // }catch(e){
        //     console.log(e)
        // }
        axios({
            'method':"GET",
            'url':`${process.env.REACT_APP_BASEURL}/v2/backgrounds/custom-walls?auth_key=${auth_key}&category=${props.prodCatId}`,
            
        })
        .then((response) => {
            setWallData(wallData => response.data)
            // setCustomWall(wall => response.data[0]['wall_png_url'])
        }).catch((e) => {
            //console.log(e)
        })
      
    }

    


    const fetchMarketPlace = () => {
        let auth_key = cookie('auth_token')
        let auth_token
        if(auth_key){
            auth_token = auth_key
        }else{
            auth_token = 'fe4a909f-9e2f-461f-98fc-51c22a21aac6'
        }
        let enterpriseId =  cookie('enterpriseId')
        const data = new FormData();
        data.append("auth_key",auth_token)
        data.append("prod_cat_id",props.prodCatId)
        data.append("enterprise_id",enterpriseId)
        axios({
            'method':"POST",
            'url':process.env.REACT_APP_BASEURL + `/v2/self-serve/get-category-market-place`,
            'data':data,

        })
        .then((res) => {
            setMarketPlaceList(res?.data?.data?.market_place_list)
        })
    }

    const fetchBackground = async (angles) => {
        let auth_key = cookie('auth_token')
        let enterpriseId =  cookie('enterpriseId')
        const data = new FormData();
        let bg_angles
        if(angles === ''){
            
            bg_angles = angle
        }else{
            bg_angles = angles
        }
        data.append("auth_key",auth_key)
        data.append("prod_cat_id",props.prodCatId)
        data.append("enterprise_id",enterpriseId)
        data.append("angle",bg_angles)
        
        // let url = process.env.REACT_APP_BASEURL + `/v2/self-serve/get-category-bg`
        // let res = await centralAPI.handlePostRequest(url,data)
        // if(res.axios_request_status === 200){
        //     setBgList(res?.data?.data?.spynelist)
        //     setFavBgList(res?.data?.data?.favList)
        //     setColorList(res?.data?.data?.color_walls)
        // }
        axios({
            'method':"POST",
            'url':process.env.REACT_APP_BASEURL + `/v2/self-serve/get-category-bg`,
            'data':data,

        })
        .then((res) => {

            setBgList(res?.data?.data?.spynelist)
            setFavBgList(res?.data?.data?.favList)
            setColorList(res?.data?.data?.color_walls)
        })
       
    }

    const fetchModel = () => {
        let auth_key = cookie('auth_token')
        if(auth_key == null){
            auth_key = 'fe4a909f-9e2f-461f-98fc-51c22a21aac6'
        }
        let sub_cat_name = props.subCatName
        const api = process.env.REACT_APP_BASEURL +`/v2/image/get-models-poses?auth_key=${auth_key}&category=${sub_cat_name}`;
        fetch(api)
            .then(response => response.json())
            .then((data) => {
                if(data.status==200){
                setModelData(data.data)
                setModelId(data.data[0].model_id); 
                setModelPose(data.data[0].poses); 
                }
            });
    }


    const set_modelId = async (model_id, pose) => {
        setModelId(model_id); 
        setModelPose(pose); 
        setPoseToDisplay([])
}
const add_poses = (input) => {
    if (poseToDisplay.indexOf(input) > -1) { 
        setPoseToDisplay(poseToDisplay => {
            let fromIndex = poseToDisplay.indexOf(input);
            let temp = poseToDisplay.filter( (e) => {
                if(e !== input)
                    return true
            })
            return temp
        })
    }
    else {
        setPoseToDisplay( [...poseToDisplay, input])
    }


}

    const handleColorBackground = (imageId,code,url) => {
        setBackgroundId(imageId)
        setBgColorCode(code)
        setbgUrl(url)
        setBgCredit(null)
    }

    const handleBackground = (imageId, imageCredit,bgUrl) => {
        setBgColorCode('')
        setBackgroundId(imageId)
        setBgCredit(imageCredit)
        setbgUrl(bgUrl)
    }

    const handleMarketId = (Id) => {
        setMarketId(Id)
    }

    const handleBackgroundList = () => {
        setShowBackgroundList(!showBackgroundList)
      }
  
    const hideList = () => {
        setShowBackgroundList(!showBackgroundList)
      }

    const handleToggleImage = () => {
        let userEmail = cookie("emailId")
        let userId = cookie("userId")
        if(isEditingFinish){
            setToggleStatus(!toggleStatus)
            if(!userId && !userEmail && !context.auth.loggedIn){
                if(toggleStatus){
                    setIsImageHide(false)
                }else{
                    setIsImageHide(true)
                }
                
            }else{
                setIsImageHide(false)
            }
            
        }
        if(bgList.length === 0 && favBgList.length === 0 && !(props.categoryType === 'fabric' || props.categoryType === 'homeFurnishing')){
            //console.log('success')
            let bgAngles = ''
            fetchBackground(bgAngles)
            fetchMarketPlace() 
            if(props.prodCatId === 'cat_d8R14zUNE'){
                fetchCustomWalls()
            }           
        }
        if(modelData.length===0 && (props.categoryType === 'fabric' || props.categoryType === 'homeFurnishing')){
            fetchModel()
        }
    }

    const handleCarsFavList=async (i,image_id) =>{

        const fd = new FormData()
        let auth_key = cookie('auth_token')
        // fd.append("auth_key", auth_key)
        fd.append("auth_key",auth_key)
        fd.append("background_id",image_id)
        fd.append("favourable","false")
        fd.append("primary","false")
        fd.append("prod_cat_id",props.prodCatId)
        await axios({
            'method':"POST",
            // 'url':`${process.env.REACT_APP_BASEURL}/v2/backgrounds/updatefavbg`,
            'url':process.env.REACT_APP_BASEURL + `/v2/self-serve/updatefavbg-self-serve`,

            "data":fd
        })
        .then((res) => {
            if (res.data.status===200){
                // let sliced= favBgList.splice(i,1)
                // bgList.unshift(sliced[0])
                // setFavBgList(favBgList)
                // setBgList(bgList)
                let angles = ''
                fetchBackground(angles)
            }
        })
    }

    const handleCarsBgList = async (i,image_id) => {
        const fd = new FormData()
        let auth_key = cookie('auth_token')
        fd.append("auth_key", auth_key)

        fd.append("background_id",image_id)
        fd.append("favourable","true")
        fd.append("primary","false")
        fd.append("prod_cat_id",props.prodCatId)
        // let url = process.env.REACT_APP_BASEURL + `/v2/self-serve/updatefavbg-self-serve`
        // let data_body = fd
        // let res = await centralAPI.handlePostRequest(url,data_body)
        // if(res.axios_request_status === 200){
        //     if (res.data.status===200){
        //         // let sliced=bgList.splice(i,1)
        //         // favBgList.unshift(sliced[0])
        //         // setFavBgList(favBgList)
        //         // setBgList(bgList)
        //         let angles = ''
        //         fetchBackground(angles)
        //     }
        // }
        await axios({
            'method':"POST",
            // 'url':`${process.env.REACT_APP_BASEURL}/v2/backgrounds/updatefavbg`,
            'url':process.env.REACT_APP_BASEURL + `/v2/self-serve/updatefavbg-self-serve`,

            "data":fd
        })
        .then((res) => {
            if (res.data.status===200){
                // let sliced=bgList.splice(i,1)
                // favBgList.unshift(sliced[0])
                // setFavBgList(favBgList)
                // setBgList(bgList)
                let angles = ''
                fetchBackground(angles)
            }
            
        })
       
    }

    const handleNumberPlate = (e) => {
        setNumberPlate(e)
        if(e === 'blur'){
            setCheckBlurNumberPlate(true)
        }else{
            setCheckBlurNumberPlate(false)
        }
    } 

    const handleWindowCorrection = () => {
        setCheckWindowCorrection(!checkWindowCorrection)
    }

    const handleColorEnhancement = () => {
        setCheckColorEnhancement(!checkColorEnhancement)
    }

    const handleAngle = (angle) => {
        setAngle(angle)
        fetchBackground(angle)
    }

    const handleCroppedImage = (finalCropedImageDetails) => {
        setCropImageDetails(finalCropedImageDetails)
    }

    const handleDownloadcropImg = async () => {
        let auth_token = cookie('auth_token')
        const cd = new FormData()
        cd.append("auth_key",auth_token)
        cd.append("left",(cropImageDetails[1])[0])
        cd.append("top",(cropImageDetails[1])[1])
        cd.append("right",(cropImageDetails[1])[2])
        cd.append("bottom",(cropImageDetails[1])[3])
        cd.append("sku_id",props.fileList[0].skuId)
        cd.append("project_id",props.fileList[0].projectId)
        cd.append("singleImage_Id",props.fileList[0].imageId)
        cd.append("image_url", props.fileList[0].fullResolutionOutput)
        let response= await axios.post(`${process.env.REACT_APP_BASEURL}/v2/image/cropper`,cd)
        if(response.status===200){
            setCropImageDetails([response?.data.display_image,[0,0,0,0]])
            await props.handleSetCropedImgUrls(response.data)
            setCropImage(false)
        }
    }

    const handleNumberPlateLogo = (blob) => {
        setSelectedLogoFile(blob)
    }

    const handleImageModalInImageSection = (image_url,isOpen) => {
        // create a state here, pass the state in image section.
        // pass this fn to virtual studio 
        isOpen ? setImageSectionModalImage(image_url) : setImageSectionModalImage(null)
    }

    const handleShadowType = (shadow_type) => {
        
        if(applyShadow){
            setShadowType(shadow_type)
        }else{
            setShadowType(null)
        }
        
    }

    return (

        <Dropzone  onDrop={acceptedFiles => props.fileUpload(acceptedFiles)} onDragEnter={props.dragStart} onDragLeave={props.dragLeave}>
{({getRootProps, getInputProps}) => (
        <div {...getRootProps({
            onClick: event => event.stopPropagation()
        })} className={Styles['dropzone-main']}>
            {props.dropBackground ?
                <section className={[Styles['drop-box-text']]}>
                <div>Drop Image Anywhere</div>  
                
                </section>
                : null
            }        

        <div>
            {/* Upload Automobile Photo Optmizer */}
            <section className={[styles['upload-screen'],'upload-screen'].join(' ')}>
                <div className={[styles[''],'container-common'].join(' ')}>
                    <div className={[styles[''],'row'].join(' ')}>
                        <div className={[styles['left-image-part'],'col-md-6 left-image-part'].join(' ')}> 
                            <ul>
                                <li><p><img src="https://storage.googleapis.com/spyne-website/self-serve/credit-blue.png"/> 
                                        {props.availableCredit === 0 ?
                                            <span onClick={props.handleModal}> Get Free Credits</span>
                                            :
                                            <a className = {[styles['credit-wallent-link']]} href ="https://www.spyne.ai/tech/pricing" target = "_blank"><span>{props.availableCredit} Credits</span></a>    
                                        }
                                        
                                    </p>
                                </li>
                                {props.subCatName !== 'suit' && props.subCatName !== 'bedsheet' ?
                                <Dropzone onDrop={acceptedFiles => props.fileUpload(acceptedFiles)} >
                                    {({getRootProps, getInputProps}) => (
                                            
                                            <li {...getRootProps({})}><p><img src="https://storage.googleapis.com/spyne-website/self-serve/upload-blue.png"/> <span> Upload New Project</span></p>
                                                    <input onChange={props.fileUpload}  type="file" {...getInputProps()} />
                                            </li>
                                    )}
                                </Dropzone>
                                :
                                <li  onClick={props.fileUpload}><p><img src="https://storage.googleapis.com/spyne-website/self-serve/upload-blue.png"/> <span> Upload New Project</span></p>
                                </li>
                                }
                            </ul>
                            <ImageSection 
                                handleToggleImage = {handleToggleImage}
                                toggleStatus = {toggleStatus}
                                fileList = {props.fileList}
                                isEditingFinish={isEditingFinish}
                                isImageHide = {isImageHide}
                                cropImageDetails={cropImageDetails}
                                cropImage={cropImage}
                                spinner={spinner}
                                handleCroppedImage={handleCroppedImage}
                                subCatName={props.subCatName}
                                categoryType={props.categoryType}
                                imgGenerationList={props.imgGenerationList}
                                frontendData={props.frontendData}
                                handleModal={props.handleModal}
                                handleUploadLoginModal={props.handleUploadLoginModal}
                                applyType={applyType}
                                customWall={customWall}
                                applyWay={applyWay}
                                setApplyWay={setApplyWay}
                                setHeight={setHeight}
                                imageSectionModalImage = {imageSectionModalImage}
                                setImageSectionModalImage = {setImageSectionModalImage}
                                isEditingFinish={isEditingFinish}
                            />
                        </div>
                        {/* Image Upload Area End  */}

                        {/* Right Section */}

                        {toggleStatus ? 
                            <div className={[styles['right-content-part'],'col-md-6 right-content-part'].join(' ')}>
                                <DownloadScreen 
                                    fileList = {props.fileList}
                                    bgCredit={bgCredit}
                                    angle={angle}
                                    availableCredit = {props.availableCredit}
                                    backgroundId={backgroundId}
                                    prodCatId={props.prodCatId}
                                    cropImageDetails={cropImageDetails}
                                    handleDownloadcropImg={handleDownloadcropImg}
                                    imgGenerationList={props.imgGenerationList}
                                    setCropImage={setCropImage}
                                    getUserCredit={props.getUserCredit}
                                    input_img_url={props.fileList[0].url}
                                />
                            </div>
                            :
                            <div className={[styles['right-content-part'],'col-md-6 right-content-part'].join(' ')}>
                                <CustomSettings 
                                    isSolidBackgrounds = {isSolidBackgrounds}
                                    favBgList = {favBgList}
                                    backgroundId = {backgroundId}
                                    handleBackground = {handleBackground}
                                    handleCarsFavList={handleCarsFavList}
                                    handleBackgroundList = {handleBackgroundList}
                                    bgList = {bgList}
                                    colorList={colorList}
                                    handleCarsBgList = {handleCarsBgList}
                                    handleNumberPlate={handleNumberPlate}
                                    numberPlate={numberPlate}
                                    isDelearshipLogo={isDelearshipLogo}
                                    isBackgroundBlur={isBackgroundBlur}
                                    handleColorEnhancement={handleColorEnhancement}
                                    checkColorEnhancement={checkColorEnhancement}
                                    handleWindowCorrection={handleWindowCorrection}
                                    checkWindowCorrection={checkWindowCorrection}
                                    isLoggedIn={props.isLoggedIn}
                                    angle={angle}
                                    handleAngle={handleAngle}
                                    handleColorBackground={handleColorBackground}
                                    marketPlaceList={marketPlaceList}
                                    setMarketId={setMarketId}
                                    marketId={marketId}
                                    frontendData={props.frontendData}
                                    imageProcessing={imageProcessing}
                                    checkShadow={checkShadow}
                                    handleCheckShadow={handleCheckShadow}
                                    handleMarketId={handleMarketId}
                                    modelData={modelData}
                                    set_modelId={set_modelId}
                                    modelPose={modelPose}
                                    modelId={modelId}
                                    add_poses={add_poses}
                                    poseToDisplay={poseToDisplay}
                                    categoryType={props.categoryType}
                                    applyType={applyType}
                                    setApplyType={setApplyType}
                                    customWall={customWall}
                                    setCustomWall={setCustomWall}
                                    wallData={wallData}
                                    applyWay={applyWay}
                                    setApplyWay={setApplyWay}
                                    setWallData={setWallData}
                                    prodCatId={props.prodCatId}
                                    checkBodyReflection={checkBodyReflection}
                                    setCheckBodyReflection={setCheckBodyReflection}
                                    setCheckBrightness={setCheckBrightness}
                                    setCheckTint={setCheckTint}
                                    setCheckBlur={setCheckBlur}
                                    handleNumberPlateLogo={handleNumberPlateLogo}
                                    prodCatId= {props.prodCatId}
                                    handleImageModalInImageSection = {handleImageModalInImageSection}
                                    shadowType = {shadowType}
                                    handleShadowType = {handleShadowType}
                                    applyShadow = {applyShadow}
                                    setApplyShadow = {setApplyShadow}
                                    seeThrough={seeThrough}
                                    setSeeThrough={setSeeThrough}
                                    greyScale={greyScale}
                                    setGreyScale={setGreyScale}
                                />

                            </div>
                        }

                    </div>
                </div>
            </section>
            {/* //Upload Automobile Photo Optmizer */}

            <BackgroundListModal 
                handleBackground={handleBackground}
                handleBackgroundList={handleBackgroundList}
                isLoggedIn={props.isLoggedIn}
                hideList = {hideList}
                showBackgroundList={showBackgroundList}
                handleCarsBgList = {handleCarsBgList}
                handleCarsFavList={handleCarsFavList}
                bgList={bgList}
                favBgList={favBgList}
                fileList = {props.fileList}
                backgroundId={backgroundId}
                imageProcessing={imageProcessing}
                applyType={applyType}
                customWall={wallData}
                customWallSelected = {customWall}
                setCustomWall={setCustomWall}
                setShowBackgroundList={setShowBackgroundList}
            />
            
        </div>
        </div>
                        )}
                </Dropzone> 
    )
}

const mapStateToProps = (state, ownProps)=>{
    //console.log({'state.homePageReducer redux':state.homePageReducer})
    return{
        tryImageDataFromRedux : state.homePageReducer.tryImageData,
        fileFromRedux : state.homePageReducer.file,
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        updateImageFileData : (file)=>dispatch(updateImageFileData(file)),
        updateImageURL : (imageURL,subCategoryId, index)=>dispatch(updateImageURL(imageURL,subCategoryId, index))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SingleImageProcessing);